export default function binaryStringToUtf8(binaryString: string) {
  const urlEncodedString = binaryString.replace(/(.)/g, (match, character) => {
    let charCode = character.charCodeAt(0).toString(16).toUpperCase();
    if (charCode.length < 2) {
      charCode = '0' + charCode;
    }

    return '%' + charCode;
  });

  return decodeURIComponent(urlEncodedString);
}
